export default __webpack_public_path__ + "static/media/stake-more-labs-uni.71207e77.svg";